module.exports = __webpack_public_path__ + "img/lbf-icon.344376df.png";